const UTILS = {
  Valod_AWB_Prefix_Array: [
    "001",
    "006",
    "014",
    "016",
    "020",
    "023",
    "037",
    "043",
    "045",
    "055",
    "057",
    "065",
    "071",
    "074",
    "077",
    "079",
    "080",
    "081",
    "082",
    "083",
    "086",
    "096",
    "098",
    "105",
    "106",
    "112",
    "114",
    "117",
    "118",
    "124",
    "125",
    "126",
    "131",
    "139",
    "145",
    "155",
    "157",
    "160",
    "172",
    "173",
    "176",
    "180",
    "203",
    "205",
    "214",
    "217",
    "232",
    "235",
    "239",
    "288",
    "297",
    "307",
    "369",
    "403",
    "406",
    "463",
    "489",
    "501",
    "555",
    "566",
    "580",
    "603",
    "607",
    "615",
    "618",
    "629",
    "657",
    "675",
    "687",
    "695",
    "699",
    "706",
    "724",
    "738",
    "756",
    "784",
    "806",
    "807",
    "810",
    "843",
    "851",
    "865",
    "871",
    "876",
    "880",
    "910",
    "921",
    "932",
    "933",
    "978",
    "988",
    "992",
    "997",
    "999"
  ],
  // 处理密度格式
  getDensity: function(density) {
    if (density) {
      var min = 0,
        max = 0;
      var densityArray = density.split("<");
      if (densityArray.length > 2) {
        min = densityArray[0];
        max = densityArray[2];
        if (min < 167 && max > 167) {
          return "";
        }
        if (min >= 167) {
          return "1:" + min;
        } else if (max <= 167) {
          return "1:" + max;
        } else {
          return "";
        }
      } else if (densityArray.length == 2) {
        return "1:" + densityArray[0];
      }
    }
    return density;
  },
  getUrlKey: function(name) {
    return (
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        decodeURIComponent(location.href)
      ) || [, ""])[1].replace(/\+/g, "%20") || null
    );
  },

  uuid: function() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
  },

  getNowFormatDate: function(date) {
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },
  prefixInteger: function(num, length) {
    return (Array(length).join("0") + num).slice(-length);
  },
  timeDiff: function(date) {
    date = date.replace(/[\-]/g, "/");
    const diff = new Date(date).getTime() - new Date().getTime();
    const timeUp = {
      day: 0,
      hour: 0,
      minute: 0,
      second: 0,
      total: 0
    };
    if (!diff) {
      return timeUp;
    }
    if (diff <= 0) {
      return timeUp;
    }
    var days = Math.floor(diff / (24 * 3600 * 1000));
    var leave1 = diff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000));
    var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000));
    var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000);
    return {
      day: days,
      hour: hours,
      minute: minutes,
      second: seconds,
      total: diff
    };
  },
  url2Obj: function(url) {
    let urlArray = url.split("?");
    let suffix = urlArray.length > 1 ? urlArray[1] : "";
    let arr = suffix.split("&"); //先通过？分解得到？后面的所需字符串，再将其通过&分解开存放在数组里
    let obj = {};
    for (let i of arr) {
      obj[i.split("=")[0]] = i.split("=")[1]; //对数组每项用=分解开，=前为对象属性名，=后为属性值
    }
    return obj;
  },
  obj2Url: function(obj) {
    let url = "";
    for (let key in obj) {
      let v = obj[key];
      if (!v || v == "null" || v == "undefined") {
        continue;
      }
      url += "&" + key + "=" + v;
    }
    if (url) {
      url = url.replace("&", "?");
    }
    return (
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      url
    );
  },

  obj2UrlQuery: function(obj) {
    let url = "";
    for (let key in obj) {
      let v = obj[key];
      if (!v || v == "null" || v == "undefined") {
        continue;
      }
      url += "&" + key + "=" + v;
    }
    if (url) {
      url = url.replace("&", "?");
    }
    return url;
  },

  uuid: function() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
  },

  checkYunModel: function() {
    let urlYunModel = this.getUrlKey("yunModel"),
      yunmodel = urlYunModel == "false" ? false : !!urlYunModel;
    return yunmodel;
  },
  replacePosition: function(string) {
    if (
      !!string &&
      string != "0.00" &&
      string != "NaN" &&
      string != "undefined"
    ) {
      var length = string.length;
      var stringArr = string.split("");
      stringArr[length - 4] = "*";
      string = stringArr.join("");
      return string;
    } else {
      return "0.00";
    }
  }
};
export default UTILS;
